(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const discounts = drawer.querySelector('[data-vp-drawer-discounts]');
  const total = drawer.querySelector('[data-vp-drawer-total]');
  const offer = drawer.querySelector('[data-vp-drawer-offer]');
  window.vpRenderDrawerOffers = (cart) => {
    if (!cart || !offer) return;
    const currency = cart.currency || 'USD';
    const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(value || 0) / 100);
    drawer.querySelector('[data-cart-drawer-subtotal]').textContent = money(cart.items_subtotal_price);
    total.textContent = money(cart.total_price);
    discounts.replaceChildren();
    for (const discount of cart.cart_level_discount_applications || []) {
      const row = document.createElement('div');
      row.className = 'dc-cart-drawer__summary-row vp-drawer-discount';
      const label = document.createElement('span');
      label.textContent = discount.title;
      const value = document.createElement('strong');
      value.textContent = '−' + money(discount.total_allocated_amount);
      row.append(label, value);
      discounts.append(row);
    }
    offer.replaceChildren();
    offer.hidden = currency !== 'USD' || !cart.item_count;
    if (offer.hidden) return;
    const heading = document.createElement('strong');
    heading.textContent = 'BLACK FRIDAY';
    offer.append(heading);
    const subtotal = Number(cart.original_total_price || 0);
    const tiers = [[30000,5000],[50000,10000],[90000,20000],[150000,40000]];
    const next = tiers.find(t => subtotal < t[0]);
    const earned = tiers.filter(t => subtotal >= t[0]).at(-1)?.[1] || 0;
    const scheduled = Date.now() < Date.parse('2026-11-01T09:00:00Z');
    const paragraph = (text, className) => {
      const p = document.createElement('p');
      p.textContent = text;
      if (className) p.className = className;
      offer.append(p);
    };
    if (scheduled) {
      paragraph('Starts November 1. Automatically applied from 9:00 AM UTC.');
      if (earned) paragraph('Your order qualifies for ' + money(earned) + ' off when the offer starts.');
    }
    if (next) paragraph('Add ' + money(next[0] - subtotal) + ' more to save ' + money(next[1]) + (earned ? ' in total.' : '.'), 'vp-drawer-next');
    else paragraph('You have reached the highest Black Friday savings tier.', 'vp-drawer-next');
  };
})();